import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import LeadsDataGrid from '../../../Lead/Page/LeadsDataGrid'
import { MemberStatus } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';

const LeadsDialog = ({ open, setOpen, campaignId, fetchLeads, fetchCampaignRelatedEntitiesCount }) => {
    const [selectedRows, setSelectedRows] = useState(null); // State to store selected row ID
    const { post } = useApiManager();
    const [memberStatus, setMemberStatus] = useState(0);

    const handleClose = () => {
        setOpen(false);
    };

    // Handler to capture selected row ID
    const handleSelectionChange = (newSelection) => {
        setSelectedRows(newSelection); // Store selected row IDs
    };

    const handleAddLead = async () => {
        if (selectedRows < 1) {
            alert("Please select a row!");
            return;
        }
        try {
            const responseData = await post(`/leadcampaigns/add-leads-to-campaign`, {
                campaignId: campaignId,
                leadIds: selectedRows,
                memberStatus: memberStatus,
                isContact: false
            });
            // console.log('Form Submitted Successfully:', responseData);
            handleClose();
            fetchLeads();
            fetchCampaignRelatedEntitiesCount();

            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Choose Lead</DialogTitle>
            <DialogContent>
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                    <LeadsDataGrid
                        onSelectionModelChange={handleSelectionChange}
                        campaignId={campaignId} />

                </Box>
                <Autocomplete
                    disablePortal
                    options={MemberStatus}
                    value={MemberStatus.find((option) => option.value === memberStatus)}
                    size="small"
                    sx={{ width: "20%", mt: 2 }}
                    onChange={(event, newValue) => setMemberStatus(newValue ? newValue.value : '')}
                    renderInput={(params) => <TextField {...params} label="Member Status" />}
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleAddLead}>Add Lead</Button>
            </DialogActions>
        </Dialog>
    )
};

export default LeadsDialog;